import { stringify } from 'query-string';
import { MAX_LIMIT } from 'config';

import { sortOrderTypes } from 'types/shared';

interface ICountriesURLArgs {
  countryIds?: string[];
  nameFilter?: string;
  limit?: number;
  offset?: number;
  sortOrder?: sortOrderTypes;
  sortBy?: string;
  isExCountries?: boolean;
}

export default function getCountriesURL(args: ICountriesURLArgs = {}): string {
  const {
    countryIds,
    nameFilter,
    limit = MAX_LIMIT,
    offset,
    sortBy,
    sortOrder,
    isExCountries,
  } = args;

  const params = stringify({
    countryIds,
    nameFilter,
    limit,
    offset,
    sortBy,
    sortOrder,
  });

  return `/api/${isExCountries ? 'ex-countries' : 'countries'}?${params}`;
}
